export const SuccessfulRegistrationBanner = ({ description }) => {
  return (
    <div id="registered-top-container-content">
      <div id="registered-title-top">
        <div id="registered-title">Success!</div>
        <div id="registered-subtitle">{description}</div>
      </div>
    </div>
  )
}
